<template>
	<div class="rightInner">
		<div class="title">
			<div class="titleLine"></div>
			{{$t('mypages.compayInfo.title')}}
		</div>
		<div class="info" v-if="isShowEdit == false">
			<ul>
				<li>{{$t('mypages.compayInfo.enterprise_label')}} {{form.enterprise}}</li>
				<li>{{$t('mypages.compayInfo.contact_name_label')}} {{form.contact_name}}</li>
				<li>{{$t('mypages.compayInfo.contact_mobile_label')}} {{form.contact_mobile}}</li>
				<li>{{$t('mypages.compayInfo.email_label')}} {{form.email}}</li>
				<li>{{$t('mypages.compayInfo.address_label')}}{{form.address}}</li>
			</ul>
			<div class="editBtn" @click="eidtClick">{{$t('mypages.compayInfo.edit')}}</div>
		</div>
		<div class="info" v-else>
			<div class="inputArea">
				<div class="inputLabel">{{$t('mypages.compayInfo.enterprise_label')}}</div>
				<input type="text" v-model="form.enterprise"/>
			</div>
			<div class="inputArea">
				<div class="inputLabel">{{$t('mypages.compayInfo.contact_name_label')}}</div>
				<input type="text" v-model="form.contact_name"/>
			</div>
			<div class="inputArea">
				<div class="inputLabel">{{$t('mypages.compayInfo.contact_mobile_label')}}</div>
				<input type="text" v-model="form.contact_mobile"/>
			</div>
			<div class="inputArea">
				<div class="inputLabel">{{$t('mypages.compayInfo.email_label')}}</div>
				<input type="text" v-model="form.email"/>
			</div>
			<div class="inputArea">
				<div class="inputLabel">{{$t('mypages.compayInfo.address_label')}}</div>
				<div>
					<div>
						<select class="countryArea " v-model="selectedCountry" @change="updateProvinces" required>
							<option v-for="(country,index) in countries" :key="country.id" :value="country">
								{{ country.name }}</option>
						</select>
						<select class="provincesArea " v-model="selectedProvince" @change="updateCities" required>
							<option value="" disabled>{{$t('mypages.compayInfo.placeholder_province')}}</option>
							<option v-for="(province,index) in provinces" :key="province.id" :value="province">
								{{ province.name }}</option>
						</select>
						<select class="cityArea" v-model="selectedCity" @change="updateAreas" v-if="cities"
							required>
							<option value="" disabled>{{$t('mypages.compayInfo.placeholder_city')}}</option>
							<option v-for="(city,index) in cities" :key="city.id" :value="city">{{ city.name }}
							</option>
						</select>
						<select class="areaArea" v-model="selectedArea" v-if="areas" required>
							<option value="" disabled>{{$t('mypages.compayInfo.placeholder_area')}}</option>
							<option v-for="(area,index) in areas" :key="area.id" :value="area">{{ area.name }}
							</option>
						</select>
					</div>
					<textarea class="textArea" :placeholder="$t('mypages.compayInfo.placeholder_address')"  v-model="form.contact_address"></textarea>
				</div>
			</div>
			<div class="btns">
				<div class="btnStyle saveBtn" @click="saveCompanyInfo">{{$t('mypages.compayInfo.save')}}</div>
				<div class="btnStyle cancelBtn" @click="hideEdit">{{$t('mypages.compayInfo.cancel')}}</div>
			</div>
		</div>
	</div>
</template>




<script>
export default{
	data(){
		return{
				selectedCountry: {},
				selectedProvince: {},
				selectedCity: {},
				selectedArea: {},
				countries: [],
				provinces: [],
				cities: [],
				areas: [],
				isShowEdit: false,
				form:
				{
					address:'',
					email:'',
					contact_mobile:'',
					contact_name:'',
					enterprise:'',
					contact_address:''
				}
			}
		},
	created(){
		this.getCompanyInfo();
	},
   mounted() {
   	this.getCountries();
   },
	methods:{
		updateProvinces() {
			this.selectedCity = {};
			this.selectedArea = {};
			this.selectedProvince = {};
			this.provinces = this.getProvincesByCountry(this.selectedCountry);
		},
		updateCities() {
			this.selectedCity = '';
			this.selectedArea = '';
			this.cities = this.getCitiesByProvince(this.selectedProvince);
		},
		updateAreas() {
			this.selectedArea = '';
			this.areas = this.getAreasByCity(this.selectedCity);
		},
		getCountries() {
			this.$scUtil.axiosPost(this, 'LocationApi/GetLocationListByLevel', {
				level: 1
			}, res => {
				if (res.code == 100) {
					this.countries = res.data;
					this.selectedCountry = this.countries[0];
					this.getProvincesByCountry(this.selectedCountry);
					//console.log(this.advertList);
				}

			});

		},
		getProvincesByCountry(country) {
			this.selectedCountry = country;
			// 这里应根据实际数据结构获取省份列表
			this.$scUtil.axiosPost(this, 'LocationApi/GetLocationListByParentId', {
				parentId: country.id
			}, res => {
				if (res.code == 100) {
					this.provinces = res.data;
					//console.log(this.advertList);
				}

			});
		},
		getCitiesByProvince(province) {
			this.selectedProvince = province;
			// 这里应根据实际数据结构获取城市列表
			this.$scUtil.axiosPost(this, 'LocationApi/GetLocationListByParentId', {
				parentId: province.id
			}, res => {
				if (res.code == 100) {
					this.cities = res.data;
					//console.log(this.cities);
				}

			});
		},
		getAreasByCity(city) {
			this.selectedCity = city;
			// 这里应根据实际数据结构获取区域列表
			this.$scUtil.axiosPost(this, 'LocationApi/GetLocationListByParentId', {
				parentId: city.id
			}, res => {
				if (res.code == 100) {
					this.areas = res.data;
					//console.log(this.advertList);
				}

			});
		},getCitiesByProvinceAsync(pid,cid) {
			// 这里应根据实际数据结构获取城市列表
			this.$scUtil.axiosPost(this, 'LocationApi/GetLocationListByParentId', {
				parentId: pid
			}, res => {
				if (res.code == 100) {
					this.cities = res.data;
					this.selectedCity=this.cities.find(p=>p.id==cid);
					//console.log(this.cities);
				}

			});
		},
		getAreasByCityAsync(cid,aid) {
			// 这里应根据实际数据结构获取区域列表
			this.$scUtil.axiosPost(this, 'LocationApi/GetLocationListByParentId', {
				parentId: cid
			}, res => {
				if (res.code == 100) {
					this.areas = res.data;
					this.selectedArea=this.areas.find(p=>p.id==aid);
				}

			});
		},
		eidtClick(){
			this.isShowEdit = true
		},
		hideEdit(){
			this.isShowEdit = false
		},
		getCompanyInfo(){
			this.$scUtil.axiosPost(this, 'MemberApi/GetCompanyInfo', {
				userName: localStorage.getItem('username'),
			}, res => {
				console.log(res.code);
				if (res.code == 100) {
					//console.log(res.data);
					this.form.contact_address=res.data[0].contact_address;
					this.form.address=res.data[0].address;
					this.form.contact_mobile=res.data[0].contact_mobile;
					this.form.email=res.data[0].email;
					this.form.contact_name=res.data[0].contact_name;
					this.form.enterprise=res.data[0].enterprise;
					this.selectedCountry=this.countries.find(p=>p.id==res.data[0].contact_countryid);
					this.selectedProvince=this.provinces.find(p=>p.id==res.data[0].contact_provinceid);
					this.cities = this.getCitiesByProvinceAsync(res.data[0].contact_provinceid,res.data[0].contact_cityid);
					this.areas = this.getAreasByCityAsync(res.data[0].contact_cityid,res.data[0].contact_areaid);
					
				}
			
			});		
		},
		saveCompanyInfo(){
			this.$scUtil.axiosPut(this, 'MemberApi/UpdateCompanyInfo', {
			contact_address:this.form.contact_address,
			contact_mobile:this.form.contact_mobile,
			email:this.form.email,
			contact_name:this.form.contact_name,
			enterprise:this.form.enterprise,
			contact_countryid:this.selectedCountry==null?0:this.selectedCountry.id,
			contact_provinceid:this.selectedProvince==null?0:this.selectedProvince.id,
			contact_cityid:this.selectedCity==null?0:this.selectedCity.id,
			contact_areaid:this.selectedArea==null?0:this.selectedArea.id,
			userName: localStorage.getItem('username'),
			}, res => {
				if (res.code == 100) {
					this.$message({
						message: res.message,
						type: "success"
					});
					this.getCompanyInfo();
					this.isShowEdit = false;
				}
				else
				{
					this.$message({
						message: res.message,
						type: "warning"
					});
				}
			});			
		}
	}
}
</script>

<style scoped>
	.rightInner{
		width: 958px;	
	}	
	
	.title{
		font-size: 14px;
		color: #000000;
		display:flex;
		align-items: center;
		height: 52px;
		border-bottom: 1px solid #e2e2e2;
		padding-left: 20px;
		background-color:#fff;
	}
	
	.titleLine{
		width: 4px;
		height: 14px;
		background-color: #0380fe;
		margin-right: 15px;
	}
	
	.info{
		width: 100%;
		padding: 20px;
		box-sizing: border-box;
		background-color: #fff;
	}
	
	.info ul li{
		font-size: 13px;
		color: #333333;
		line-height: 40px;
		list-style: none;
	}
	
	.editBtn{
		width: 117px;
		height: 33px;
		background-color: #0380fe;
		color: #fff;
		font-size: 13px;
		text-align: center;
		line-height: 33px;
		margin-top: 15px;
		border-radius: 3px;
	}

	.inputArea{
		display: flex;
		align-items: baseline;
		margin-bottom: 20px;
	}

	.inputArea input{
		width: 319px;
		height: 32px;
		border: 1px solid#e2e2e2;
		padding:0 18px;
		color: #333333;
	}

	.inputLabel{
		width: 91px;
		text-align: left;
		font-size: 13px;
		color: #333333;
	}

	select{
		width: 112px;
		height: 31px;
		margin-right: 11px;
		border: 1px solid #e2e2e2;
		color: #333;
	}

	.textArea{
		border: 1px solid #e2e2e2;
		font-size: 13px;
		color: #333333;
		width: 319px;
		height: 84px;
		padding: 18px;
		margin-top: 20px;
	}

	
	.btns{
    cursor: pointer;
    display: flex;
    padding-left: 95px;
    margin-bottom: 20px;
  }

  .btnStyle{
    width: 97px;
    height: 33px;
    font-size: 12px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .saveBtn{
    border: 1px solid #0380fe;
    background: #0380fe;
    color: #fff;
    margin-right: 20px;
  }

  .cancelBtn{
    border: 1px solid #d9d9d9;
    background: #fff;
    color: #333;
  }
</style>